module.exports = __webpack_public_path__ + "static/media/fr-shyju.179fb574.png";